import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import {
  SetupDomainResponse,
  SetupHrisIntegration,
  SetupHrisResponse,
  SetupSlackResponse,
  SetupSSOResponse,
} from '@/types/setup';

type SetupDomainParams = {
  returnUrl: string;
  successUrl: string;
};

type SetupSSOParams = {
  returnUrl: string;
  successUrl: string;
};

type SetupHrisParams = {
  integration: SetupHrisIntegration;
};

export const setupApi = createApi({
  reducerPath: 'setupApi',
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getSetupDomain: builder.query<SetupDomainResponse, SetupDomainParams>({
      query: params => ({
        url: ENDPOINT.SETUP.GET_DOMAIN(),
        method: 'GET',
        params,
      }),
    }),
    getSetupSSO: builder.query<SetupSSOResponse, SetupSSOParams>({
      query: params => ({
        url: ENDPOINT.SETUP.GET_SSO(),
        method: 'GET',
        params,
      }),
    }),
    getSetupHris: builder.query<SetupHrisResponse, SetupHrisParams>({
      query: params => ({
        url: ENDPOINT.SETUP.GET_HRIS(),
        method: 'GET',
        params,
      }),
    }),
    getSetupSlack: builder.query<SetupSlackResponse, void>({
      query: params => ({
        url: ENDPOINT.SETUP.GET_SLACK(),
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useGetSetupDomainQuery,
  useGetSetupSSOQuery,
  useGetSetupHrisQuery,
  useLazyGetSetupDomainQuery,
  useLazyGetSetupSSOQuery,
  useLazyGetSetupHrisQuery,
  useLazyGetSetupSlackQuery,
} = setupApi;
